/**
 * Created by TF on 2018/6/20
 */

import Mock from 'mockjs'

const Dynamic = [];
for (let i = 0; i < 10; i++) {
  Dynamic.push(Mock.mock({
    id: Mock.Random.guid(),
    name:Mock.Random.first(),
    deadlineStart : Mock.Random.date(),
    deadlineEnd : Mock.Random.date(),
    source : Mock.Random.cname(),
    type :Mock.Random.cname(),
    zzgk : Mock.Random.cname(),
    checkResult: Mock.Random.cname(),
    fxwtjcl: Mock.Random.cname(),
    summarize: Mock.Random.cname(),
    fileUrl:Mock.Random.cname()

  }))
}

const Project = [];
for (let i = 0; i < 100; i++) {
  Project.push(Mock.mock({
    id: Mock.Random.guid(),
    name: Mock.Random.cname(),
    addr: Mock.mock('@county(true)'),
    'age|18-60': 1,
    birth: Mock.Random.date(),
    sex: Mock.Random.integer(0, 1)
  }))
}

export {Dynamic,Project}



// WEBPACK FOOTER //
// ./src/mock/data/userCenter.js